<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>

<div class="row">

  <div class="columnnbv1">
    <div class="position-fixed-scans2 border-right2  height-100pe">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 padding-right-0px">
        <div class="card height-100vh">
          <div class="card-header wh-header border-bottom padding-bottom-0px">
            <div class="row">
              <div class="col-md-12">
                <label class="margin-bottom-0px">Department User</label>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row border-bottom-2px">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <div class="row">
                  <div class="col-md-12 text-align-center padding-left-0px">
                    <img class="img-circle-50" [src]='DepartmentUserImage' onError="this.src='dummy.jpg';">
                  </div>
                </div>
                <div class="row margin-left-zero margin-top-10">
                  <div class="col-md-12 text-align-center padding-left-0px">
                    <label class="font-size-16px margin-bottom-0px">{{DepartmentUserName}}</label>
                  </div>
                </div>                
                <div class="row margin-left-zero">
                  <div class="col-md-12 text-align-center padding-left-0px">
                    <label class="font-size-16px margin-bottom-0px">{{DepartmentUserRole}}</label>
                  </div>
                </div>
 
              </div>
            </div>
            <div class="row border-bottom-2px  background-consumption">

              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <div class="row ">
                  <div class="col-md-11">
                    <label class="margin-bottom-0px font-weight-normal">Consumption Group</label>
                  </div>
                </div>   
                                 
                   <div class="row margin-left-0px margin-top-5px margin-bottom-5px">
                      <div class="col-md-12 padding-left-0px my-profile-form">                      
                      <CustomDataByRequestType RequestedType="Consumption Groups"  class="form-group"
                        SelectedValue="Consumptioncode"
                        [(ngModel)]="Consumptioncode" (keyChange)="onAssignedToActorCodesurgeon($event)"
                                                                     name="Consumptioncodename"  #sign1="ngModel">
                      </CustomDataByRequestType>
                        </div>
                    </div>
                  </div>
              </div>
            <div class="row border-bottom-2px  background-store  margin-top-5px">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <div class="row ">
                  <div class="col-md-9">
                    <label class="margin-bottom-0px font-weight-normal">Store/Department</label>
                  </div>                  
                </div>
                <div class="row margin-left-0px margin-top-5px margin-bottom-5px">
                  <div class="col-md-12 padding-left-0px my-profile-form">
                    <CustomDataByRequestType RequestedType="AccessibleStores" FacilityCode={{FacilityCode}} ActorCode={{ActorCode}} class="form-group"  SelectedValue="StoreCode"
                        [(ngModel)]="StoreCode" (keyChange)="onAssignedToActorCodesurgeon2($event)"
                                                                     name="StoreCodename"  #sign2="ngModel">
                    </CustomDataByRequestType>
                  </div>
                </div>
              </div>
            </div>
           </div>
        </div>
      </div>
    </div>
  </div>
  <div class="columnnbv2  margin-top-17px">
    <div class="card height-100vh ">
              <div class="card-header wh-header  padding-bottom-0px padding-left-0px padding-right-0px padding-t-6px header-fixed">
                <div class="row border-bottom padding-bottom-5px margin-left-0px margin-right-0px">
                  <div class="col-md-4">
                    <label class="margin-bottom-0px margin-left-5px">Items </label>
                  </div>
                  <div class="offset-md-3 col-md-5 float-right">
                    <div class="row">                      
                      <div class=" offset-md-3 col-md-9 padding-left-0px" *ngIf="Code">
                        <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" (click)="Cancel()">Cancel </button>
                        <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right margin-right-5px" (click)="SaveDataConsumption()">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                        <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right margin-right-5px" (click)="Finalize()" *ngIf="Code !=0">Finalize</button>
                      </div>
                    </div>                    
                  </div>
                </div>
                <div class="row border-top border-bottom bk-color-light margin-left-0px margin-right-0px">
                  <div class="col-md-3 border-right-1px padding-right-0px padding-left-0px text-align-center">
                    <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Order Date</label></div>
                    <div><label class="margin-bottom-0px font-size-16px color-Assign" *ngIf="Date">{{Date| date:'MMM-dd-yyyy'}}</label></div>
                  </div>
                  <div class="col-md-3 border-right-1px padding-right-0px padding-left-0px text-align-center">
                    <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Branch</label></div>
                    <div><label class="margin-bottom-0px font-size-16px color-Assign" *ngIf="BranchName">{{BranchName}}</label></div>
                  </div>
                  <div class="col-md-3 border-right-1px padding-right-0px padding-left-0px text-align-center">
                    <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">purpose</label></div>
                    <div class="margin-top-3px"><label class="margin-bottom-0px font-size-11px color-Assign" *ngIf="ConsumptionGroupName">{{ConsumptionGroupName}}</label></div>
                  </div>
                  <div class="col-md-3 border-right-1px padding-right-0px padding-left-0px text-align-center">
                    <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Total Cost</label></div>
                    <div ><label class="margin-bottom-0px font-size-16px color-Assign" *ngIf="TotalBill">{{TotalBill}}</label></div>
                  </div>


                </div>
              </div>
              <div class="card-body  padding-bottom-0px padding-left-0px padding-right-0px padding-top-92px">
                <div class="chatsd product-chart-wrapper agreement-chart-wrapper ps2 padding-lrt height-80pe">
                  <div class="row padding-top-3px">
                    <div class="col-md-12">
                      <div class="table-component">
                        <div class="table-responsive overflow-x">
                          <table class="table table-striped margin-left-20p table-fixed"
                                 cols="auto,2*,*,*,*,*,*,*">
                            <thead class="">
                              <tr>

                                <th class="min-width-24px padding-top-4px padding-bottom-4px th-sticky">
                                  #
                                </th>


                                <th class="padding-top-4px padding-bottom-4px th-sticky">
                                  Service Description
                                </th>
                                <th class="text-align-center padding-top-4px padding-bottom-4px th-sticky">
                                  UOM
                                </th>
                                <th class="padding-top-4px padding-bottom-4px th-sticky">
                                  QTY
                                </th>


                                <th class="text-align-center padding-top-4px padding-bottom-4px th-sticky">
                                  Unit Price
                                </th>



                                <th class="text-align-center padding-top-4px padding-bottom-4px th-sticky">
                                  Item Cost
                                </th>

                                <!--<th class="padding-top-4px padding-bottom-4px th-sticky">
                                  
                                </th>-->
                              </tr>
                            </thead>

                            <tbody class="table-body">
                              <tr *ngFor="let l of CurrentConsumpationData;let i = index">


                                <td class="td-padding-tb">
                                  {{i+1}}
                                </td>
                                <td class=" td-padding-tb">
                                  <div>{{l.ItemName}}</div>
                                  <div *ngIf="l.SupplierBatchDetails==='0'"><a (click)="ViewItem(l)" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New Registration">Select Batch</a></div>
                                  <div *ngIf="l.SupplierBatchDetails!=='0'"><a (click)="ViewItem(l)" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New Registration">Batch : {{l.SupplierBatchDetails}}</a></div>
                                </td>
                                <td class="text-align-center td-padding-tb padding-right-0px">{{l.Uom}}</td>
                                <td class="text-align-center td-padding-tb">
                                  <!--<input type="number" class="form-control text-align-right td-width-82px" placeholder=""
    [(ngModel)]="l.quantity"
    maxlength="2" required>-->
                                  <label  class="margin-bottom-0px">{{l.Quantity}}</label>
                                
                                </td>
                                <td class="text-align-center td-padding-tb padding-right-0px">{{l.ItemCost}}</td>


                                <td class="td-padding-tb text-align-center padding-right-0px"> <label class="margin-bottom-0px">{{l.ItemCost * l.Quantity}}</label></td>
                                <!--<td class=" td-padding-tb ">
                                   <a (click)="delete(i)" class="nav-link-hand font-size-16px color-Rejected" title="Remove"><i class="far fa-trash-alt nav-link-hand"></i></a>
                                  
                                </td>-->



                              </tr>
                            </tbody>



                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

    </div>
  </div>

  <div class="columnbp3 background-white margin-top-17px">

    <div class="position-fixed-Activities3">
      <div class="card">
        <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px padding-t-6px padding-left-8px">
          <div class="row">
            <div class="col-md-12">
              Store Materials
            </div>
            <div class="col-md-12 line-height-10px">
              <label class="margin-bottom-0px font-size-12px color-Assign" *ngIf="StoreName">({{StoreName}})</label>
            </div>
          </div>

          <div class="row margin-top-5px margin-bottom-10px margin-left-0px">
            <div class="col-md-10 padding-left-0px">
              <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>

            </div>



          </div>
        </div>
        <div class="card-body padding-top-0px padding-left-0px padding-right-0px padding-bottom-0px">

          <div class="chatsd product-chart-wrapper product-chat-height-600 agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
            <div class="table-component actor-table">

              <div class="table-responsive padding-right-11px">


                <table class="table table-striped table2">
                  <tbody>
                    <tr *ngFor="let l of pdata">
                      <td class="td-padding-2px">

                        <div class="row margin-left-zero margin-right">
                          <div class="col-md-2  margin-tb-auto padding-right-0px padding-left-0px">
                            <button type="button"
                                    (click)="AddRow(l)"
                                    class="btn  btn-sm plus-button " id="FileUpload"
                                    name="upload">
                              <i class="fas fa-plus font-size-11p"></i>
                            </button>
                          </div>
                          <div class="col-md-10 margin-tb-auto padding-left-0px">
                            <label class="margin-bottom-0px color3">{{l.Description}}</label>

                          </div>
                        </div>


                      </td>
                    </tr>

                  </tbody>
                </table>
              </div>
            </div>
          </div>




        </div>
      </div>
    </div>

    



  </div>


</div>
